import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconAzure(props: IconProps) {
  return (
    <BaseIcon size={40} {...props} viewBox="0 0 40 40">
      <path
        fill="url(#a)"
        d="M14.001 3h10.653L13.595 35.766a1.698 1.698 0 0 1-1.609 1.155h-8.29a1.696 1.696 0 0 1-1.607-2.238L12.392 4.156A1.699 1.699 0 0 1 14.002 3Z"
      />
      <path
        fill="#0078D4"
        d="M29.482 24.977H12.588a.781.781 0 0 0-.534 1.354L22.91 36.462c.316.295.732.46 1.164.46h9.565l-4.158-11.945Z"
      />
      <path
        fill="url(#b)"
        d="M14.001 3a1.685 1.685 0 0 0-1.613 1.178L2.101 34.655a1.694 1.694 0 0 0 1.6 2.266h8.504a1.818 1.818 0 0 0 1.395-1.186l2.051-6.046 7.328 6.834c.307.254.692.395 1.09.398h9.53l-4.18-11.944-12.184.003L24.692 3h-10.69Z"
      />
      <path
        fill="url(#c)"
        d="M27.608 4.154A1.695 1.695 0 0 0 26 3H14.128a1.696 1.696 0 0 1 1.607 1.154L26.04 34.683a1.697 1.697 0 0 1-1.607 2.239h11.872a1.696 1.696 0 0 0 1.607-2.24L27.608 4.155Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="17.884"
          x2="6.821"
          y1="5.514"
          y2="38.197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="21.34"
          x2="18.78"
          y1="20.745"
          y2="21.611"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity=".3" />
          <stop offset=".071" stopOpacity=".2" />
          <stop offset=".321" stopOpacity=".1" />
          <stop offset=".623" stopOpacity=".05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="19.933"
          x2="32.077"
          y1="4.561"
          y2="36.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
